import React, {Component} from 'react';
import {observer} from 'mobx-react';
import intl from 'react-intl-universal';
import Mousetrap from 'mousetrap';
import Button from '../../components/Button/index';
import * as SurveyJS from "survey-react";

@observer
class Survey extends Component {
    constructor(props) {
        super(props);
        this.submitHandler = this.submitHandler.bind(this);
        SurveyJS.StylesManager.applyTheme("bootstrapmaterial");

        // console.log('SURVEY CONSTRUCTOR - create model');
    }

    exitModal = () => {
        this.props.navigate('/');
        this.props.appStore.tracking.click('Closed Survey Modal');
    };
    onFocus = (el) => {
        let element = document.getElementById(el);
        if (!element.classList.contains('mousetrap')) {
            element.classList.add('mousetrap');
        }
    };
    componentDidMount = () => {
        Mousetrap.bind(['escape'], this.exitModal);
        this.props.appStore.tracking.pageview('Survey');
    };
    componentWillUnmount = () => {
        Mousetrap.unbind(['escape'], this.exitModal);
    };
    submitHandler = (form) => {
        if(!this.props.appStore.standalone){
            this.props.navigate('/end');
            return;
        }
        this.props.appStore.submitData(form.data, (responseVal)=>{
            if(responseVal){
                this.props.navigate('/end');
            }else{
                this.props.navigate('/error');
            }
        });

    };
    ErrorListTemplate = (props) => {
        const {errors} = props;
        return (
            <div>
                {errors.map((error, i) => {
                    return (
                        <li key={i}>
                            {error.message}
                        </li>
                    );
                })}
            </div>
        );
    };

    focusFirst = el => {
        if (el && this.props.appStore.standalone) {
            setTimeout(() => {
                el.survey.focusFirstQuestion();
            }, 300);
        }
    };

    valueChanged = () => {
        this.props.appStore.setSurveyStarted();
    };

    getLang=()=>{
        const {appStore} = this.props;
        if(!appStore.meta.type.lang) return "";
        if(appStore.meta.type.lang === 'es-ES'){
            return "es";
        }if(appStore.meta.type.lang === 'zh-CN'){
            return "zh-cn";
        }if(appStore.meta.type.lang === 'it-IT'){
            return "it";
        }if(appStore.meta.type.lang === 'vi-VI'){
            return "vi";
        }
        return "";
    };

    createMarkup = (string) => {
        return {__html: string};
    };

    render() {
        const {appStore} = this.props;
        const surveySchema = appStore.buildSurveySchema();
        if (appStore.appConfig.survey && appStore.appConfig.survey.length > 0) {
            return (
                <div className={(appStore.isMobile) ? "Survey mobile" : "Survey desktop"}>
                    <div className="content">
                        <div className={"container"}>
                            {/*<iframe src="https://www.surveygizmo.com/s3/4722589/CoMap-embed-test"/>*/}
                            <link rel="stylesheet"
                                  href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0-beta.3/css/bootstrap.min.css"
                                  integrity="sha384-Zug+QiDoJOrZ5t4lssLdxGhVrurbmBWopoEl+M6BdEfwnCJZtKxi1KgxUyJq13dy"
                                  crossOrigin="anonymous"/>

                            <Button className='btn returnToMap btn-secondary' aria-label="Close button" onClick={this.exitModal}>
                                {intl.get("Landing.back_to_map")}
                            </Button>

                            <h1 dangerouslySetInnerHTML={this.createMarkup(appStore.appConfig.content.demographics.headline)} />
                            <p dangerouslySetInnerHTML={this.createMarkup(appStore.appConfig.content.demographics.description)} />

                            {!appStore.mapDataSubmitted &&
                            <SurveyJS.Survey
                                ref={el => this.focusFirst(el)}
                                key={surveySchema.id}
                                model={new SurveyJS.Model(surveySchema)}
                                onComplete={this.submitHandler}
                                completeText={intl.get("MapContainer.submit")}
                                onValueChanged={this.valueChanged}
                                locale={this.getLang()}
                            />}

                            {appStore.mapDataSubmitted &&
                            <div className="loading_container">
                                <p>{intl.get("Survey.submitting")}</p>
                                <img className="loading_spinner" src="imgs/loading.gif" alt="Loading..."/>
                            </div>
                            }
                        </div>
                    </div>

                </div>
            );
        } else {
            return (<div></div>);
        }

    }
}

export default Survey;



// WEBPACK FOOTER //
// ./src/scenes/Survey/index.js